/**
 * 장례식장 주소로 제주 여부 판별. 서버는 sido.sgis_code == "39" 로 판별하지만
 * 프론트 응답엔 sido가 없어 주소 첫 단어로 대신한다 ("제주특별자치도 ..." / "제주 ...").
 * includes가 아닌 startsWith: "경상남도 창원시 제주길" 같은 도로명 오탐 방지.
 */
export const isJejuAddress = (address?: string | null) =>
  Boolean(address?.trim().startsWith("제주"));
